import { render, staticRenderFns } from "./TableData.vue?vue&type=template&id=66b7fe3e&scoped=true"
import script from "./TableData.vue?vue&type=script&lang=js"
export * from "./TableData.vue?vue&type=script&lang=js"
import style0 from "./TableData.vue?vue&type=style&index=0&id=66b7fe3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b7fe3e",
  null
  
)

export default component.exports